import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import './FileViewerModal.css';
import BackEnd from '../backend/BackEnd';

const $ = window.jQuery;

class FileViewerModal extends Component {
    static propTypes = {
        documentUrl: PropTypes.string,
        documentId: PropTypes.number,
        requireToken: PropTypes.bool,
        allowDownload: PropTypes.bool,
        createUrl: PropTypes.func,
        viewer: PropTypes.func.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {
        requireToken: true,
        allowDownload: true
    };
    state = {
        isLoading: false,
        documentUrl: null
    };

    async componentDidMount() {
        if (this.props.documentId)
            await this.fetchDocumentUrl();
    }

    async componentWillReceiveProps(nextProps) {
        if (this.props.documentId !== nextProps.documentId && nextProps.documentId)
            await this.fetchDocumentUrl(nextProps.documentId);
    }

    render() {
        const {
            documentUrl,
            documentId,
            requireToken,
            allowDownload,
            createUrl,
            viewer,
            ...props
        } = this.props;
        const loadingSpinner = (
            <div className="text-center m-t-2">
                <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
            </div>
        );

        return (
            <Modal {...props} className="modal-xl" bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Просмотр документа</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        this.state.isLoading
                            ? loadingSpinner
                            : viewer(documentUrl || this.state.documentUrl)
                    }
                </Modal.Body>
                <Modal.Footer>
                    {
                        this.props.allowDownload &&
                        <button type="button" className="btn btn-primary"
                                onClick={() => this.download()}>
                            Скачать
                        </button>
                    }
                    <button type="button" className="btn btn-default"
                            onClick={props.onHide}>
                        Закрыть
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    async fetchDocumentUrl(documentId = this.props.documentId) {
        if (!documentId)
            return;

        const {requireToken, createUrl} = this.props;

        const getFileToken = new BackEnd.Tokens.GetFileToken(this);
        const token = requireToken
            ? await getFileToken.call()
            : null;

        const downloadFile = new BackEnd.Documents.View();
        const documentUrl = createUrl
            ? createUrl(token)
            : downloadFile.createUrl({documentId, token});

        this.setState({documentUrl});
    }

    async download() {
        const {documentUrl, documentId} = this.props;

        if (documentUrl) {
            $('<a />').attr({
                href: documentUrl,
                download: documentUrl.split("/").reverse()[0]
            }).get(0).click();
        }
        else if (documentId) {
            const downloadFile = new BackEnd.Documents.Download();
            const href = downloadFile.createUrl({documentId});

            $('<a />').attr({href, download: 'download'}).get(0).click();
        }
    }
}

export default FileViewerModal;


// WEBPACK FOOTER //
// ./src/modals/FileViewerModal.js